import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const deleteInvoiceCodeTransaction = createAction(Constants.DELETE_INVOICE_CODE_FROM_TRANSACTION.REQUEST, (datas) => (datas));
export const clearState = createAction(Constants.CLEAR_MODAL_INVOICE_CODE_2_TRANSACTION,  () => ({}));

